//公共模块,接口维护
var urlContant = require('./urlconstant.js');

module.exports = {
  URL: urlContant
}



// WEBPACK FOOTER //
// ./src/constant/constant.js